import intlTelInput from 'intl-tel-input';

export function phoneinput(elem, elements) {
  var iti = intlTelInput(elem, {
    utilsScript: '../../build/js/utils.js',
    initialCountry: elem.dataset.countryCode,
    nationalMode: false,
    preventInvalidDialCodes: true,
    formatOnDisplay: false
  });

  elements.each(function () {
    if (this) {
      window.Parsley.addValidator('phoneValidate', function (value) {
        var countryData = iti.getSelectedCountryData().dialCode;
        // elem.value = value.length ===;
        if (!value || value.length === 0) { return; }
        return iti.isValidNumber();
      }, 32)
        .addMessage('en', 'phoneValidate', I18n.t('js.valid_phone_number')); // eslint-disable-line no-undef
    }
  });
}

window.phoneinput = phoneinput;

$(document).ready(function () {
  phoneinput(document.querySelector('.phone-input'), $('.phone-input'));

  var $input = $('.phone-input');
  $input.on('mousedown', function(){
    if($(this).val().length === 0){
      var val = $(this).attr('placeholder').split(' ')[0];
      $(this).val(val);
    }
  })
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/intl-tel-input.js